import store from '@/store'

import async from 'async'

import restResource from '@/technical/restResource'

// import treeviewData from '@/technical/components/Treeview/treeviewData'
// import treeviewDataMethods from '@/technical/components/Treeview/treeviewDataMethods'

import serverData from '@/store/serverData'

export default function (options, callback) {
  if (options == null) return callback(null)

  serverData.loadingDataStatus.mainCommonData = serverData.loadingDataStatus.types.LOADING

  async.parallel({
    // /////////////////////////////////////////////////////////////////

    users: function (cb) {
      if ((options.all === false) && (options.users === false)) return cb(null, true)
      if ((options.all === true) || (options.users === true)) {} else return cb(null, true)
      // console.log('users')
      var users = {}
      var usersThatExist = {}
      var userResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.userResource)
      userResource.query()
      .then(function (response) {
        if (response.data == null) return cb('что-то не так')
        for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
          users[response.data[itemIndx].id] = response.data[itemIndx]
          if (response.data[itemIndx].Deleted === 0) usersThatExist[response.data[itemIndx].id] = response.data[itemIndx]
        }
        /* arrayTools.sort(users, function (a, b) {
          return a.Name < b.Name
        }) */
        store.commit('commonDataUsersSet', users)
        store.commit('commonDataUsersThatExistSet', usersThatExist)
        cb(null, true)
      })
      .catch((error) => cb(error))
    },

    // /////////////////////////////////////////////////////////////////

    usersGroups: function (cb) {
      if ((options.all === false) && (options.usersGroups === false)) return cb(null, true)
      if ((options.all === true) || (options.usersGroups === true)) {} else return cb(null, true)
      // console.log('usersGroups')
      var usersGroups = {}
      var userGroupResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.userGroupResource)
      userGroupResource.query()
      .then(function (response) {
        if (response.data == null) return cb('что-то не так')
        for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
          usersGroups[response.data[itemIndx].id] = response.data[itemIndx]
        }
        store.commit('commonDataUsersGroupsSet', usersGroups)
        cb(null, true)
      })
      .catch((error) => cb(error))
    },

    // /////////////////////////////////////////////////////////////////

    news: function (cb) {
      if ((options.all === false) && (options.news === false)) return cb(null, true)
      if ((options.all === true) || (options.news === true)) {} else return cb(null, true)
      // console.log('news')
      var news = {}
      var newsResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.newsResource)
      newsResource.query({sort: 'createdAt desc'})
      .then(function (response) {
        if (response.data == null) return cb('что-то не так')
        for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
          // news[response.data[itemIndx].id] = response.data[itemIndx]
          news[itemIndx] = response.data[itemIndx]
        }
        store.commit('commonDataNewsSet', news)
        cb(null, true)
      })
      .catch((error) => cb(error))
    },

    // /////////////////////////////////////////////////////////////////

    partners: function (cb) {
      if ((options.all === false) && (options.partners === false)) return cb(null, true)
      if ((options.all === true) || (options.partners === true)) {} else return cb(null, true)

      serverData.partnersReload(function (error) {
        if (error) cb(error)
        cb(null, true)
      })
    },

    // /////////////////////////////////////////////////////////////////

    finixBanks: function (cb) {
      if ((options.all === false) && (options.finixBanks === false)) return cb(null, true)
      if ((options.all === true) || (options.finixBanks === true)) {} else return cb(null, true)

      serverData.finixBanksReload(function (error) {
        if (error) return cb(error)
        cb(null, true)
      })
    },

    // /////////////////////////////////////////////////////////////////

    appSettings: function (cb) {
      if ((options.all === false) && (options.appSettings === false)) return cb(null, true)
      if ((options.all === true) || (options.appSettings === true)) {} else return cb(null, true)

      serverData.appSettingsReload(function (error) {
        if (error) return cb(error)
        cb(null, true)
      })
    },

    // /////////////////////////////////////////////////////////////////

    tasks: function (cb) {
      if ((options.all === false) && (options.tasks === false)) return cb(null, true)
      if ((options.all === true) || (options.tasks === true)) {} else return cb(null, true)
      // console.log('tasks')
      var tasks = {}
      var taskResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.taskResource)
      taskResource.query()
      .then(function (response) {
        if (response.data == null) return cb('что-то не так')
        for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
          var oneTaskResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.taskResource)
          oneTaskResource.val = response.data[itemIndx]
          tasks[oneTaskResource.val.id] = oneTaskResource
        }
        store.commit('commonDataTasksSet', tasks)
        cb(null, true)
      })
      .catch((error) => cb(error))
    },

    // /////////////////////////////////////////////////////////////////

    taskBoards: function (cb) {
      if ((options.all === false) && (options.taskBoards === false)) return cb(null, true)
      if ((options.all === true) || (options.tasksBoards === true)) {} else return cb(null, true)
      // console.log('taskBoards')
      var taskBoards = {}
      var taskBoardsResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.taskBoardsResource)
      taskBoardsResource.query({populate: '[members]'})
      .then(function (response) {
        if (response.data == null) return cb('что-то не так')
        for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
          var oneTaskBoardResource = restResource(store.getters.appSettings.server.host + store.getters.appSettings.server.taskBoardsResource)
          oneTaskBoardResource.val = response.data[itemIndx]
          taskBoards[oneTaskBoardResource.val.id] = oneTaskBoardResource
        }
        store.commit('commonDataTaskBoardsSet', taskBoards)
        cb(null, true)
      })
      .catch((error) => cb(error))
    }

      // /////////////////////////////////////////////////////////////////
  }, function (error, results) { // results: {users: true, news: true}
    if (error) serverData.loadingDataStatus.mainCommonData = serverData.loadingDataStatus.types.LOADING
    else serverData.mainCommonDataLoadedSetTrue()

    callback(error)
  })
}



// WEBPACK FOOTER //
// ./src/components/mainCommonDataLoader.js